let UA = window.ZZCFL.Utils.UA;
let userAgent = navigator.userAgent || '';
const userAgentLowerCase = userAgent.toLowerCase();

const isAliPay = /alipayclient/.test(window.navigator.userAgent.toLowerCase());

function getiOSVersion() {
    const ua = userAgent.toLowerCase();
    if (ua.indexOf('like mac os x') > 0) {
        const reg = /os [\d._]*/gi;
        const verinfo = ua.match(reg);
        const version = (verinfo + '').replace(/[^0-9|_.]/gi, '').replace(/_/gi, '.');
        const arr = version.split('.');
        return Number(arr[0]) >= 14;
    }
    return false;
}

const isWechat = UA.browser.name === 'weixin';
const isIos = UA.os.name === 'ios';
const isAndroid = UA.os.name === 'android';
const isHarmony = /openharmony/.test(window.navigator.userAgent.toLowerCase());

// noinspection JSUnresolvedVariable
const isWechatMiniProgram =
    isWechat && (window.navigator.userAgent.match(/miniprogram/i) || window.__wxjs_environment === 'miniprogram');
// 主小程序
// noinspection SpellCheckingInspection
export const mainMiniProgramAppId = 'wxa561560bddd738b2';
const isMainMiniProgram =
    isWechatMiniProgram && window?.localStorage?.getItem('wechatMiniProgramAppId') === mainMiniProgramAppId;

// 校园小程序
export const communityMiniProgramAppId = 'wxf4231f35bfc2032c';
const isCommunityMiniProgram =
    isWechatMiniProgram && window?.localStorage?.getItem('wechatMiniProgramAppId') === communityMiniProgramAppId;

function isBaiduBoxJisu() {
    return (isAndroid && /lite baiduboxapp/.test(userAgent)) || (isIos && /info baiduboxapp/.test(userAgent));
}
export default {
    isApp: /ZZC(Android|IOS|OpenHarmony)\/black\//.test(navigator.userAgent),
    isOilMajia: /knightcard_vestOil/.test(window.navigator.userAgent),
    isAppVest: /knightcard_vest1/.test(window.navigator.userAgent),
    isOilElephant: /elephant/.test(window.navigator.userAgent), // 🐘加油
    isWechat,
    isWechatBrowser: UA.browser.name === 'weixin' && !userAgent.includes('miniProgram'),
    isWechatMini: UA.browser.name === 'weixin' && userAgent.includes('miniProgram'),
    isWechatMiniProgram,
    isMainMiniProgram,
    isWap: UA.browser.name !== 'black' && UA.browser.name !== 'weixin', // 更准确的判断
    isIos,
    isAndroid,
    isHarmony,
    isSkeleton: /^SKELETON\//.test(userAgent),
    // 是否广东移动app
    isGDMobile: /GDMobile\//.test(userAgent),
    isAilPayApp: isAliPay,
    isAlipay: isAliPay,
    isAliPayMini: isAliPay && userAgentLowerCase.includes('miniprogram'),
    isiOS14: getiOSVersion(),
    // 百度极速版App
    isBaiduBoxJisu: isBaiduBoxJisu(),
    isCommunityMiniProgram,
    isHarmoneyQskApp: /ZZC(Android|IOS|OpenHarmony)\/black\//.test(navigator.userAgent) && isHarmony,
};
